export const LIMIT_MACRO_QUESTIONS_LIST = 10; // The same value is set in atlassian-connect.json: modules.dynamicContentMacros[0].parameters[limit].defaultValue
export const LIMIT_QUESTIONS = 15;
export const LIMIT_TOPICS = 15;
export const LIMIT_SPACES = 100;
export const LIMIT_ANSWERS = 25;
export const TOP_EXPERTS = 10;
export const TOPIC_EXPERTS = 10;
